import axios from "../../service/index";
import React, { Component } from "react";
import "./addRecord.less";
import { Icon, message } from "antd";
import { DatePicker, List, Button, Picker, TextareaItem } from "antd-mobile";
import { createForm } from "rc-form";
import moment from "moment";

const nowTimeStamp = Date.now();
const now = new Date(nowTimeStamp);
const utcOffset = new Date(now.getTime() - now.getTimezoneOffset() * 60000);

class AddRecord extends Component {
  state = {
    dpValue: now,
    idt: utcOffset.toISOString().slice(0, 10),
    district: [],
    tracelist: [],
    type: "",
    nexttracetime: "2022-05-05",
    planstudytime: "",
    remark: "",
  };

  componentDidMount() {
    this.getTracelist();
  }

  // 获取跟单学员类型字典
  getTracelist() {
    axios.post("tracelist", {}).then((res) => {
      this.setState({ loading: false });
      const { msg, data, code } = res.data;
      console.log(msg, data, code);
      if (code === "200") {
        console.log(data);
        let renderData = data.map((item) => {
          return {
            ...item,
            label: item.dname,
            value: item.did,
          };
        });
        console.log(renderData);
        this.setState({ district: renderData });
      } else {
        message.error(msg);
      }
    });
  }

  onSubmit = () => {
    this.props.form.validateFields({ force: true }, (error) => {
      if (!error) {
        console.log(this.props.form.getFieldsValue());
        let { type, remark, nexttracetime, planstudytime } =
          this.props.form.getFieldsValue();

        if (type === "" || (type && type.length === 0)) {
          message.error("请选择学员类型！");
          return;
        }

        if (!remark) {
          message.error("请输入跟单内容！");
          return;
        }

        if (nexttracetime) {
          nexttracetime = moment(nexttracetime).format("YYYY-MM-DD HH:mm:ss");
        }
        if (planstudytime) {
          planstudytime = moment(planstudytime).format("YYYY-MM-DD HH:mm:ss");
        }
        let askid = this.props.history.location.state.askId;
        let kefuid = this.props.history.location.state.kefuId;
        let reqData = {
          type: type[0],
          remark,
          nexttracetime,
          planstudytime,
          askid,
          kefuid,
        };
        axios.post("documentaryRecord/add", reqData).then((res) => {
          this.setState({ loading: false });
          const { msg, data, code } = res.data;
          console.log(msg, data, code);
          if (code === "200") {
            this.props.history.goBack();
          } else {
            message.error(msg);
          }
        });
      } else {
        console.log(error);
      }
    });
  };

  validateIdp = (rule, date, callback) => {
    if (isNaN(Date.parse(date))) {
      callback(new Error("Invalid Date"));
    } else {
      const cDate = new Date(date);
      const newDate = new Date(+this.state.dpValue);
      newDate.setFullYear(cDate.getFullYear());
      newDate.setMonth(cDate.getMonth());
      newDate.setDate(cDate.getDate());
      // this.setState({ dpValue: newDate });
      setTimeout(() => this.props.form.setFieldsValue({ dp: newDate }), 10);
      callback();
    }
  };

  validateDatePicker = (rule, date, callback) => {
    if (date && date.getMinutes() !== 15) {
      callback();
    } else {
      callback(new Error("15 is invalid"));
    }
  };

  backFn() {
    this.props.history.goBack();
  }

  render() {
    const { getFieldProps, getFieldError } = this.props.form;
    const { district } = this.state;
    return (
      <div className="addRecordPage">
        <div className="title">
          <span>添加跟单记录</span>
          <span onClick={this.backFn.bind(this)}>
            <Icon type="left" /> 返回
          </span>
        </div>
        <form>
          <List>
            <div>
              <div className="labelText require">
                <b>❊</b>
                <span>学员类型：</span>
              </div>
              <Picker
                className="wrapDiv"
                data={district}
                cols={1}
                error={!!getFieldError("type")}
                {...getFieldProps("type", {
                  initialValue: this.state.type,
                })}
              >
                <List.Item arrow="horizontal"></List.Item>
              </Picker>
            </div>
            <div>
              <div className="labelText require">
                <b>❊</b>
                <span>跟单内容：</span>
              </div>
              <TextareaItem
                rows={5}
                maxLength="300"
                placeholder="请输入跟单内容"
                error={!!getFieldError("remark")}
                {...getFieldProps("remark", {
                  initialValue: this.state.remark,
                })}
              ></TextareaItem>
            </div>
            <div>
              <div className="labelText">下次跟单时间：</div>
              <DatePicker
                format="datetime"
                locale={{ okText: "确认", dismissText: "取消" }}
                {...getFieldProps("nexttracetime")}
              >
                <List.Item arrow="horizontal"></List.Item>
              </DatePicker>
            </div>
            <div>
              <div className="labelText">预计学习时间：</div>
              <DatePicker
                format="datetime"
                locale={{ okText: "确认", dismissText: "取消" }}
                {...getFieldProps("planstudytime", {
                  initialValue: this.state.planstudytime,
                })}
              >
                <List.Item arrow="horizontal"></List.Item>
              </DatePicker>
            </div>
            <div>
              <Button type="primary" onClick={this.onSubmit}>
                确定
              </Button>
            </div>
          </List>
        </form>
      </div>
    );
  }
}

export default createForm()(AddRecord);
